/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */
import campaignService from 'tradera-apps/syi/script/app_react/services/campaign-service';
import ThrottledAction from 'tradera-apps/syi/script/app_react/utils/throttled-action';
import userData from 'tradera-apps/syi/script/app_react/services/user-data';
import feesActions from './fees-actions';
import draftActions from './draft-actions';
import shippingActions from './shipping-actions';
import { getSyiSlice } from 'tradera-state/views/syi/selectors/syi';

const CHARITIES = userData?.charities || [];
let throttleTimeout = 2000;
let throttledCampaignCodeValidation = new ThrottledAction(throttleTimeout);
let delayedValidationTimeoutId = null;

const findBrandAttributeValues = getState => {
    if (
        !getSyiSlice(getState()).attributes ||
        !getSyiSlice(getState()).attributes.categoryAttributes
    ) {
        return [];
    }

    let brandAttributeValues = [];
    getSyiSlice(getState()).attributes.categoryAttributes.forEach(attribute => {
        const brandAttributeId = 3; //Brand Attribute has Id == 3
        if (attribute.id != brandAttributeId) {
            return;
        }
        if (attribute.options.length === 0) {
            return;
        }
        brandAttributeValues = attribute.options.reduce((acc, option) => {
            if (option.isActive) {
                acc.push(option.value);
            }
            return acc;
        }, []);
    });
    return brandAttributeValues;
};

const resetCharityCampaign = (dispatch, getState) => {
    const { name, forceFreeShipping: wasForceFreeShipping } = getSyiSlice(
        getState()
    ).charityCampaign;
    if (!name) {
        return;
    }
    dispatch({
        type: 'RESET_CHARITY_CAMPAIGN'
    });
    dispatch({
        type: 'DISABLE_ZERO_DAY_AUCTIONS'
    });
    if (wasForceFreeShipping) {
        dispatch(shippingActions.resetSelected());
    }
};

const resetCampaign = dispatch => {
    dispatch(resetCharityCampaign);
    dispatch({
        type: 'RESET_CUSTOM_END_TIME_FEE_FREE_FOR_CAMPAIGN'
    });
    dispatch({
        type: 'UNSET_UNSOLD_FEE_FREE_FOR_CAMPAIGN'
    });
    dispatch({
        type: 'ENABLE_RESTART'
    });
    dispatch({
        type: 'RESET_MAX_FEE_CAP'
    });
    dispatch({
        type: 'RESET_CAMPAIGN_BANNER'
    });
    dispatch(feesActions.resetDiscountFactor());
    dispatch(feesActions.resetCampaignCommission());

    dispatch(feesActions.updateCommission());
    dispatch(feesActions.updateMaxCommission());
    dispatch(feesActions.updatePrices());
};

const applyCharityFromCampaignCodeId = (
    campaignCodeId,
    campaignCode
) => dispatch => {
    const charityCampaign = CHARITIES.find(
        charityCampaign => charityCampaign.campaignCodeId === campaignCodeId
    );

    if (!charityCampaign) {
        dispatch(resetCharityCampaign);
        return;
    }

    dispatch({
        type: 'SET_CHARITY_CAMPAIGN',
        charityCampaign,
        campaignCode
    });
    const {
        allowZeroDayAuctions,
        forceFreeShipping,
        forcePaymentOption
    } = charityCampaign;

    if (allowZeroDayAuctions) {
        dispatch({
            type: 'ENABLE_ZERO_DAY_AUCTIONS'
        });
    }

    if (forceFreeShipping) {
        dispatch({
            type: 'FORCE_FREE_SHIPPING'
        });
    }

    if (forcePaymentOption) {
        dispatch({
            type: 'ENSURE_ANY_PAYMENT_OPTION_FOR_CHARITY'
        });
    }

    dispatch(draftActions.setDisplayPromoted(false));
    dispatch(draftActions.setDisplayHighlighted(false));
};

const validateCampaignCode = () => (dispatch, getState) => {
    let campaignCode = getSyiSlice(getState()).campaignCode.campaignCode;
    if (!campaignCode || campaignCode.trim().length === 0) {
        return;
    }
    dispatch({
        type: 'VALIDATING_CAMPAIGN_CODE_BY_SEARCHING'
    });
    const isReadOnly = getSyiSlice(getState()).campaignCode.isReadOnly;
    throttledCampaignCodeValidation.execute(function() {
        let category = getSyiSlice(getState()).category;
        const brandAttributeValues = findBrandAttributeValues(getState);
        campaignService
            .validate(
                campaignCode,
                category.draftCategoryId,
                brandAttributeValues
            )
            .then(result => {
                // If the campaign is read-only, ignore if the code is invalid since it has already been used.
                if (isReadOnly) {
                    result.campaignCodeValid = true;
                    result.campaignCodeMessage = null;
                }

                const {
                    bannerDesktopImageUrl,
                    bannerMobileImageUrl,
                    bannerTabletImageUrl,
                    campaignCodeId,
                    campaignCodeMessage,
                    campaignCodeValid,
                    discountFactor = null,
                    hasEnded,
                    isCustomLengthFeeFree,
                    isUnsoldFeeFree,
                    maxFeeCap,
                    provisionFactor = null,
                    validationDisplayMessage
                } = result;

                const campaignCodeDescription = campaignCodeValid
                    ? campaignCodeMessage
                    : validationDisplayMessage;

                dispatch({
                    type: 'SET_CAMPAIGN_VALIDATION_RESULT',
                    bannerDesktopImageUrl,
                    bannerMobileImageUrl,
                    bannerTabletImageUrl,
                    campaignCode,
                    campaignCodeDescription,
                    campaignCodeId,
                    campaignCodeValid,
                    hasEnded,
                    maxFeeCap
                });

                if (!campaignCodeValid) {
                    dispatch(resetCampaign);
                    return;
                }

                if (isCustomLengthFeeFree) {
                    dispatch({
                        type: 'SET_CUSTOM_END_TIME_FEE_FREE_FOR_CAMPAIGN'
                    });
                }

                if (isUnsoldFeeFree) {
                    dispatch({
                        type: 'SET_UNSOLD_FEE_FREE_FOR_CAMPAIGN'
                    });
                }

                dispatch({
                    type: 'DISABLE_RESTART'
                });

                if (userData.isCompanyUser) {
                    dispatch(feesActions.setDiscountFactor(discountFactor));
                    dispatch(feesActions.setCampaignCommission(null));
                } else {
                    const commissionProcent =
                        provisionFactor !== null
                            ? `${provisionFactor * 100}`
                            : null;
                    dispatch(
                        feesActions.setCampaignCommission(commissionProcent)
                    );
                    dispatch(feesActions.setDiscountFactor(null));
                }

                dispatch(
                    applyCharityFromCampaignCodeId(campaignCodeId, campaignCode)
                );

                dispatch(feesActions.updateCommission());
                dispatch(feesActions.updateMaxCommission());
                dispatch(feesActions.updatePrices());
            });
    });
};

const saveTypedCampaignCode = inputCampaignCode => (dispatch, getState) => {
    const campaignCode = inputCampaignCode?.trim() || null;
    dispatch({
        type: 'SET_UNVERIFIED_CAMPAIGN_CODE',
        campaignCode
    });

    if (delayedValidationTimeoutId) {
        clearTimeout(delayedValidationTimeoutId);
    }

    if (campaignCode === null) {
        dispatch(resetCampaign);
        return;
    }

    delayedValidationTimeoutId = setTimeout(() => {
        clearTimeout(delayedValidationTimeoutId);
        dispatch(validateCampaignCode());
        delayedValidationTimeoutId = setTimeout(() => {
            if (getSyiSlice(getState()).campaignCode.searching) {
                dispatch({
                    type: 'SEARCHING_FOR_CAMPAIGN_CODE_IS_DELAYED'
                });
            }
        }, 100);
    }, 700);
};

const setInitialCampaignCode = (
    campaignCode,
    campaignCodeId,
    campaignCodeDescription,
    isChangeItem
) => dispatch => {
    let isReadOnly = campaignCodeId && isChangeItem;

    dispatch({
        type: 'INITIALIZE_CAMPAIGN_CODE_STATE',
        campaignCode,
        campaignCodeId,
        campaignCodeDescription,
        isReadOnly
    });
    dispatch(resetCampaign);

    // Always validate because this fetches info about the campaign like free shipping etc.
    // If the campaign is read-only, ignore if the code is invalid since it has already been used.
    dispatch(validateCampaignCode());
};

const toggleShowInput = isChecked => dispatch => {
    clearTimeout(delayedValidationTimeoutId);
    dispatch({
        type: 'TOGGLE_CAMPAIGN_CODE_CHECKBOX',
        isChecked: isChecked
    });
    dispatch(resetCampaign);
};

export default {
    toggleShowInput,
    setInitialCampaignCode,
    saveTypedCampaignCode,
    validateCampaignCode
};
